import React from 'react';
import { Redirect } from 'react-router-dom';

import { EditRecipePageSteps } from 'config/routes';

import Step from 'components/stepper/Step';
import AccessBlocked from 'components/recipes/AccessBlocked';

import useEditRecipe from 'domain/recipe/useEditRecipe';

import RecipeEditMenu from './RecipeEditMenu';
import RecipeEditSingleFormPageStep from './RecipeEditSingleFormPageStep';

const EditRecipeBodyLoadedStep = ({
  id,
  step,
  pageTitle,
  router,
  userOwnsRecipe,
  exitPage,
  goToMenuPage,
  recipeContent,
  onRecipeSaved,
}) => {
  const {
    isEditing,
    editedRecipeContent,
    setEditedRecipeContent,
    hasRecipeChanged,
    saveRecipe,
  } = useEditRecipe({ id, recipeContent, onRecipeSaved });

  if (!userOwnsRecipe)
    return (
      <Step
        stepTitle={pageTitle}
        onBackButtonClick={exitPage}
        spacing={8}
        renderBody={() => <AccessBlocked></AccessBlocked>}
      ></Step>
    );

  if (step === EditRecipePageSteps.menu)
    return (
      <Step
        stepTitle={pageTitle}
        onBackButtonClick={exitPage}
        spacing={8}
        renderBody={() => (
          <RecipeEditMenu
            isLoading={isEditing}
            router={router}
            recipeContent={editedRecipeContent}
            showEditWarning={hasRecipeChanged}
            onSaveButtonClick={saveRecipe}
          ></RecipeEditMenu>
        )}
      ></Step>
    );

  if (Object.keys(EditRecipePageSteps).includes(step))
    return (
      <RecipeEditSingleFormPageStep
        onBackButtonClick={goToMenuPage}
        recipeContent={editedRecipeContent}
        setRecipe={setEditedRecipeContent}
        spacing={8}
        step={step}
        stepTitle={pageTitle}
        onInputSubmit={goToMenuPage}
      ></RecipeEditSingleFormPageStep>
    );

  return <Redirect to={router(EditRecipePageSteps.menu)}></Redirect>;
};

export default EditRecipeBodyLoadedStep;
